import { Box, VStack } from "@chakra-ui/react";
import { FeedCardContentBlock } from "src/components/feed-card/feed-card-content-block";
import { TFeedCardGroupBody } from "src/components/feed-card/types/content";

export interface IFeedCardGroupProps {
    content: TFeedCardGroupBody;
}

export const FeedCardGroup = ({ content }: IFeedCardGroupProps) => (
    <VStack spacing={1} alignItems="stretch">
        {content.map((item, index) => (
            <Box key={index}>
                <FeedCardContentBlock {...item} />
            </Box>
        ))}
    </VStack>
);
